export class GeneratorsUtility {
  public static generateGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public static generateIdFromString(str: string): string {
    return str
      .replace(/\s/g, '_')
      .toLowerCase()
      .replace(/[áàãâä]/gi, 'a')
      .replace(/[éèêë]/gi, 'e')
      .replace(/[íìîï]/gi, 'i')
      .replace(/[óòõôö]/gi, 'o')
      .replace(/[úùûü]/gi, 'u')
      .replace(/[ç]/gi, 'c')
      .replace(/[ñ]/gi, 'n')
      .replace(/[^a-z0-9_]/g, '');
  }

  public static generateHashFromBoundingBox(boundingBox: number[]): number {
    const str = boundingBox.join('');
    let _hash = 0;

    if (str.length == 0) return _hash;

    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      _hash = (_hash << 5) - _hash + char;
      _hash = _hash & _hash;
    }

    return _hash;
  }

  public static generateHashFromString(value: string): number {
    const str = value;
    let _hash = 0;

    if (str.length == 0) return _hash;

    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      _hash = (_hash << 5) - _hash + char;
      _hash = _hash & _hash;
    }

    return _hash;
  }
}
